/**
 * Pure MVP / availability rules for Super Admin navigation.
 * Extracted for characterization tests — behavior must match mvp-config.jsx wrappers.
 */

export const SA_MVP_LEGACY_ROUTES = {
  usuarios: 'equipe',
};

export const SA_MVP_HIDDEN_ROUTES = new Set([
  'tickets', 'knowledge-base', 'support-reports', 'atendimento',
]);

export const SA_MOCK_ONLY_PAGES = new Set(['config', 'perfis']);

export const SA_SHOW_FUTURE_PAGES_KEY = 'tezus-sa-show-future-pages';

export function resolveLegacyRoute(page, legacyRoutes = SA_MVP_LEGACY_ROUTES) {
  if (!page) return page;
  return legacyRoutes[page] || page;
}

/**
 * NOTE (existing behavior): FEATURE_SUPPORT_MODULES is intentionally NOT consulted here.
 * Support pages remain in SA_MVP_HIDDEN_ROUTES even when the sidebar shows them.
 */
export function isRouteAllowedInMvp(page, {
  legacyRoutes = SA_MVP_LEGACY_ROUTES,
  hiddenRoutes = SA_MVP_HIDDEN_ROUTES,
  featureIntegrations = false,
  featureObservability = false,
} = {}) {
  if (!page) return false;
  const resolved = resolveLegacyRoute(page, legacyRoutes);
  if (hiddenRoutes.has(resolved)) return false;
  if (resolved === 'integrations' && !featureIntegrations) return false;
  if (resolved === 'observabilidade' && !featureObservability) return false;
  return true;
}

export function isPrototypeRoute(page, {
  featureIntegrations = false,
  featureObservability = false,
  featureRepairs = false,
} = {}) {
  if (page === 'integrations') return !featureIntegrations;
  if (page === 'observabilidade') return !featureObservability;
  if (page === 'repairs') return !featureRepairs;
  return false;
}

export function isFuturePage(page, opts = {}) {
  if (!page) return false;
  const resolved = resolveLegacyRoute(page, opts.legacyRoutes);
  if (resolved === 'planos') return true;
  if (resolved === 'tech-spec') return true;
  if (resolved === 'billing') return true;
  return isPrototypeRoute(resolved, opts);
}

export function isMockOnlyPage(page, {
  legacyRoutes = SA_MVP_LEGACY_ROUTES,
  mockOnlyPages = SA_MOCK_ONLY_PAGES,
} = {}) {
  if (!page) return false;
  const resolved = resolveLegacyRoute(page, legacyRoutes);
  return mockOnlyPages.has(resolved);
}

export function isLocalHost(hostname) {
  const host = String(hostname != null ? hostname : '').toLowerCase();
  if (!host) return false;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (host === 'manage.localhost' || host.endsWith('.localhost')) return true;
  return false;
}

export function getShowFuturePages({
  getItem,
  hostname,
  storageKey = SA_SHOW_FUTURE_PAGES_KEY,
} = {}) {
  try {
    if (typeof getItem === 'function') {
      const raw = getItem(storageKey);
      if (raw === 'true') return true;
      if (raw === 'false') return false;
    }
  } catch (e) { /* ignore */ }
  return isLocalHost(hostname);
}

export function setShowFuturePages(value, {
  setItem,
  storageKey = SA_SHOW_FUTURE_PAGES_KEY,
} = {}) {
  const next = value === true;
  try {
    if (typeof setItem === 'function') {
      setItem(storageKey, next ? 'true' : 'false');
    }
  } catch (e) { /* ignore */ }
  return next;
}
